import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { LoginComponent } from './login.component';
import { PreLoginComponent } from './prelogin.component';
import { HomeComponent } from './home.component';
import { RegisterComponent } from './register.component';
import { FooComponent } from './foo.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ListComponent } from './list.component';
import { TopupComponent } from './topup.component';
import { RevoGridModule, RevogrOverlaySelection, RevogrScrollVirtual, RevogrViewportScroll, RevogrTempRange, RevogrEdit, RevogrFilterPanel, RevogrFocus, RevogrHeader, RevogrOrderEditor, RevogrClipboard, RevogrData } from '@revolist/angular-datagrid';
import { tokenInterceptor } from './token.interceptor';
import { HttpClientModule } from '@angular/common/http';
import { ReCaptchaModule } from 'angular7-recaptcha';
import { PrePinComponent } from './prepin.component';
import { ChangePinComponent } from './changepin.component';
import { QuestionaireComponent } from './questionaire/questionaire.component';
import { WalletComponent } from './wallet.component';
import { ScanComponent } from './scan.component';
import { LogoutComponent } from './logout.component';
import { ConsentComponent } from './consent.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    PreLoginComponent,
    PrePinComponent,
    PrePinComponent,
    FooComponent,
    ListComponent,
    TopupComponent,
    ChangePinComponent,
    WalletComponent,
    ScanComponent,
    ConsentComponent,
    RevogrScrollVirtual,
    RevogrViewportScroll,
    RevogrOverlaySelection,
    RevogrTempRange,
    RevogrOrderEditor,
    RevogrHeader,
    RevogrFocus,
    RevogrFilterPanel,
    RevogrEdit,
    RevogrClipboard,
    RevogrData,
    QuestionaireComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,ReactiveFormsModule,
    NgxSpinnerModule,
    NgxJsonViewerModule,
    RevoGridModule,
    HttpClientModule,
    ReCaptchaModule,
    // RecaptchaFormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent },
      //{ path: 'list', component: ListComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: 'login/:username', component: LoginComponent },
      { path: 'prelogin', component: PreLoginComponent },
      { path: 'prelogin/:username', component: PreLoginComponent },
      { path: 'prelogin/:username/:password', component: PreLoginComponent },
      { path: 'consent', component: ConsentComponent },
      // { path: 'changepin', component: ChangePinComponent },
      //{ path: 'changepin/:phone/:pin', component: ChangePinComponent }, 
      //{ path: 'prepin', component: PrePinComponent },
      //{ path: 'topup', component: TopupComponent },
      //{ path: 'logout', component: LogoutComponent },
      //{ path: 'questionaire', component: QuestionaireComponent },
      //{ path: 'wallet', component: WalletComponent },
      //{ path: 'scan/:mywalletid', component: ScanComponent },
      { path: 'logout', component: LogoutComponent }], { useHash: false })
  ],

  providers: [
    tokenInterceptor
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
